export const TRANSFER_TYPE_ARRIVAL = 'arrival';
export const TRANSFER_TYPE_DEPARTURE = 'departure';
